<template>
  <v-row>
    <v-col cols="12" sm="4"  md="4">
      <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
        <v-col class="d-flex justify-center">
          <v-icon size="80" color="primary" >mdi-account-group-outline</v-icon>
        </v-col>
        <div class="font-size-11 text-center cl-grey text-capitalize ml-1">Left Members</div>
        <h1>
          <div class="text-center cl-primary font-weight-500">{{ totalDownline.total_kiri | toNumber }}</div>
        </h1>
      </v-card>
    </v-col>
    <v-col cols="12" sm="4"  md="4">
      <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
        <v-col class="d-flex justify-center">
          <v-icon size="80" color="primary" >mdi-account-group-outline</v-icon>
        </v-col>
        <div class="font-size-11 text-center cl-grey text-capitalize ml-1">Right Members</div>
        <h1>
          <div class="text-center cl-primary font-weight-500">{{ totalDownline.total_kanan | toNumber }}</div>
        </h1>
      </v-card>
    </v-col>
    <v-col cols="12" sm="4"  md="4">
      <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
        <v-col class="d-flex justify-center">
          <v-icon size="80" color="primary" >mdi-account-group-outline</v-icon>
        </v-col>
        <div class="font-size-11 text-center cl-grey text-capitalize ml-1">Total Members</div>
        <h1>
          <div class="text-center cl-primary font-weight-500">{{ totalDownline.total_downline | toNumber }}</div>
        </h1>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  props: {
    totalDownline: Object
  }
}
</script>